module.exports = __webpack_public_path__ + "static/media/hhod0.67b2afb3.wav";